import { defineMessages } from 'react-intl';

export default defineMessages({
    account: {
        id: 'gateway.views.quote-detail.Account',
        defaultMessage: 'Account'
    },
    activities: {
        id: 'gateway.views.quote-detail.Activities',
        defaultMessage: 'Activities'
    },
    continueQuote: {
        id: 'gateway.views.quote-detail.Continue Quote',
        defaultMessage: 'Continue Quote'
    },
    createdDate: {
        id: 'gateway.views.quote-detail.Created Date',
        defaultMessage: 'Date Created'
    },
    documents: {
        id: 'gateway.views.quote-detail.Documents',
        defaultMessage: 'Documents'
    },
    effectiveDate: {
        id: 'gateway.views.quote-detail.Effective Date',
        defaultMessage: 'Effective Date'
    },
    note: {
        id: 'gateway.views.quote-detail.Note',
        defaultMessage: 'Note'
    },
    notes: {
        id: 'gateway.views.quote-detail.Notes',
        defaultMessage: 'Notes'
    },
    openActivities: {
        id: 'gateway.views.quote-detail.Open Activities',
        defaultMessage: 'Open Activities'
    },
    openIssues: {
        id: 'gateway.views.quote-detail.Open Issues',
        defaultMessage: 'Open UW Issues'
    },
    policy: {
        id: 'gateway.views.quote-detail.Policy',
        defaultMessage: 'Policy'
    },
    premium: {
        id: 'gateway.views.quote-detail.Premium',
        defaultMessage: 'Premium'
    },
    status: {
        id: 'gateway.views.quote-detail.Status',
        defaultMessage: 'Status'
    },
    summary: {
        id: 'gateway.views.quote-detail.Summary',
        defaultMessage: 'Summary'
    },
    premiumQuoteCalculated: {
        id: 'gateway.views.quote-detail.The premium for this quote has been calculated',
        defaultMessage: 'The premium for this quote has been calculated'
    },
    quoteHasBeenBound: {
        id: 'gateway.views.quote-detail.This quote has been bound',
        defaultMessage: 'This quote has been bound'
    },
    quoteSuccessfullyStarted: {
        id: 'gateway.views.quote-detail.This quote has been successfully started',
        defaultMessage: 'This quote has been successfully started.'
    },
    thisQuoteHasBeenWithDrawn: {
        id: 'gateway.views.quote-detail.This quote has been withdrawn',
        defaultMessage: 'This quote has been withdrawn.'
    },
    withdrawQuote: {
        id: 'gateway.views.quote-detail.WithdrawQuote',
        defaultMessage: 'Withdraw Quote'
    },
    continiueQuoteQizard: {
        id: 'gateway.views.quote-detail.You may either withdraw or continue to the quote wizard',
        defaultMessage: 'You may either withdraw or continue to the quote wizard.'
    },
    changeQuoteWizardToBind: {
        id: 'gateway.views.quote-detail.You may either withdraw or continue to the quote wizard where you can bind the quote.',
        defaultMessage: 'You may either withdraw or continue to the quote wizard where you can bind the quote.'
    },
    mayWithdrawQuote: {
        id: 'gateway.views.quote-detail.You may withdraw the quote',
        defaultMessage: 'You may withdraw the quote'
    },
    sureWithDrawQuote: {
        id: 'gateway.directives.JobSummary.Are you sure you want to withdraw quote:',
        defaultMessage: 'Are you sure you want to withdraw quote:'
    },
    failedWithdrawSubmission: {
        id: 'gateway.directives.JobSummary.Failed to withdraw submission',
        defaultMessage: 'Failed to withdraw submission'
    },
    withdraw: {
        id: 'gateway.directives.JobSummary.Withdraw',
        defaultMessage: 'Withdraw'
    },
    withdrawJob: {
        id: 'gateway.directives.JobSummary.WithdrawJob',
        defaultMessage: 'Withdraw Quote?'
    },
    printQuoteDoc: {
        id: 'gateway.directives.JobSummary.Print Quote Document',
        defaultMessage: 'Print Quote Document'
    },
    printAppDoc: {
        id: 'gateway.directives.JobSummary.Print App Document',
        defaultMessage: 'Print App Document'
    },
    printQuoteSuccessMsg: {
        id: 'gateway.directives.JobSummary.Document generated successfully. Please refer the Documents tab.',
        defaultMessage: 'Document generated successfully. Please refer the Documents tab.'
    },
    printQuoteFailureMsg: {
        id: 'gateway.directives.JobSummary.Unable to generate the document.',
        defaultMessage: 'Unable to generate the document.'
    }
});
